import { formatDate } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import {  faCalendarWeek } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrl: './datepicker.component.scss',
    standalone: false
})
export class DatepickerComponent {
  @Input() maxDate: string = '';
  @Input() minDate: string = '';
  @Input() control: FormControl;
  @Input() value: string;
  @Input() borderColor   : string = '#5f6d7e';
  formattedDate: string = '';
  faCalendar = faCalendarWeek

  openDatePicker(event: any) {
    setTimeout(() => {
      event.target.showPicker?.();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      const newValue = changes['value'].currentValue;
      if (newValue) {
        this.formattedDate = this.getFormattedDate(newValue);
      } else {
        this.formattedDate = '';
      }
    }
  }

  onDateChange(event: Event) {
    const dateValue = (event.target as HTMLInputElement).value;
    this.control?.setValue(dateValue);
    this.formattedDate = this.getFormattedDate(dateValue);
  }
  
  getFormattedDate(rawDate: string): string {
    if (!rawDate) return '';
    return formatDate(rawDate, 'dd-MMM-yy', 'en-IN');
  }

}
